import React, {Component} from 'react';
import PropTypes from 'prop-types';

import paths from 'paths';

import {t} from 'l10n';

import 'sass/headers/header.scss';

class HeaderContacts extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <header className="contacts">
                <div className="content">
                    <h1>{t('Contact')}</h1>
                    <div
                        className="text-subtitle"
                        dangerouslySetInnerHTML={{__html:
                            t(
                                'If your message is related to a technical problem, please visit %1. This page has answers for all frequently asked questions.',
                                <a href={paths.faq.path}>{t('Help page')}</a>
                            )
                        }}
                    />
                </div>
            </header>
        )
    }
}

HeaderContacts.contextTypes = {
    router: PropTypes.object
};

export default HeaderContacts;


// WEBPACK FOOTER //
// ./src/components/contacts/HeaderContacts.js